import { Routes } from '@angular/router';

export const CONTENT_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('../../modules/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'archive',
    loadChildren: () => import('../../modules/archive/archive.module').then(m => m.ArchiveModule)
  },
  {
    path: 'user',
    loadChildren: () => import('../../modules/user/user.module').then(m => m.UserModule)
  },
  {
    path: 'layout',
    loadChildren: () => import('../../modules/layout/layout.module').then(m => m.LayoutModule)
  },
  {
    path: 'station',
    loadChildren: () => import('../../modules/station/station.module').then(m => m.StationModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('../../modules/admin/admin.module').then(m => m.AdminModule)
  }
];
